import { render, staticRenderFns } from "./ProductOffersTable.vue?vue&type=template&id=a69c0aae&scoped=true"
import script from "./ProductOffersTable.vue?vue&type=script&lang=js"
export * from "./ProductOffersTable.vue?vue&type=script&lang=js"
import style0 from "./ProductOffersTable.vue?vue&type=style&index=0&id=a69c0aae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a69c0aae",
  null
  
)

export default component.exports